/**
 * The cases constants module houses cases-specific configurations.
 *
 * @module routes.simulation.states.constants
 */

angular.module('routes.simulation.states.constants', [])
  .config([
    '$provide',
    function ($provide) {
      'use strict';

      // Define.
      var states;

      // Set defaults.
      states = {
        templates: [],
        models: []
      };


      // TODO: This should be done in a more efficient manner
      //  configs should be imported or loaded, not hardcoded

      states.templates['state.learningOutcomes'] = {
        rule: {
          stop: true,
          scored: false,
          active: true,
          totalPoints: 0,
          decision: {
            multiple: false,
            scored: false,
            model: 'none',
            choices: [
              {
                correct: true,
                target: '_self',
                id: 'string',
                feedback: 'string',
                points: 0
              }
            ]
          }
        },
        decision: {
          stem: '',
          choices: [
            {
              id: '',
              label: ''
            }
          ]
        }
      };

      states.templates['state.contentView'] = {
        rule: {
          stop: true,
          active: true,
          totalPoints: 0,
          decision: {
            multiple: false,
            scored: false,
            model: 'none',
            choices: [
              {
                correct: true,
                target: '_self',
                id: 'string',
                feedback: 'string',
                points: 0
              }
            ]
          }
        },
        decision: {
          stem: '',
          choices: [
            {
              id: '',
              label: ''
            }
          ]
        }
      };

      states.templates['state.choiceDecision'] = {
        rule: {
          stop: true,
          active: true,
          totalPoints: 0,
          decision: {
            multiple: false,
            scored: false,
            model: 'none',
            choices: [
              {
                correct: true,
                target: '_self',
                id: 'string',
                feedback: 'string',
                points: 0
              }
            ]
          }
        },
        decision: {
          stem: '',
          choices: [
            {
              id: '',
              label: ''
            }
          ]
        }
      };


      states.models['state.learningOutcomes'] = {
        title: '',
        list: [
          {
            value: ''
          }
        ],
        choices: [
          {
            value: '',
            target: '',
            points: 0
          }
        ]
      };

      states.models['state.contentView'] = {
        title: '',
        scored: false,
        multiple: false,
        model: 'none',
        stem: '',
        choices: [
          {
            value: '',
            target: '',
            points: 0,
            correct: false
          }
        ]
      };

      states.models['state.choiceDecision'] = {
        title: '',
        scored: false,
        multiple: false,
        model: 'none',
        stem: '',
        choices: [
          {
            value: '',
            target: '',
            points: 0,
            correct: false
          }
        ]
      };

      /**
       * Defines states constants.
       *
       * @attribute STATES
       * @type String
       * @readOnly
       */
      $provide.constant('STATES', states);
    }
  ]);
